export default __webpack_public_path__ + "static/media/Ford_Takeover_2.54174bbb.jpg";